import apiClient, { safeJson } from '@/api/client';
import { ReserveBody, ReserveResponse, CancelResponse, ReservationsResponse, MemberBookingsResponse } from './types';

export const reserveSession = async (centerId: string, sessionId: string, body: ReserveBody) => {
    const res = await apiClient.post(`v1/centers/${centerId}/group-sessions/${sessionId}/reserve`, { json: body });
    return { status: res.status, data: await safeJson(res) as ReserveResponse | null };
};

export const cancelReservation = async (centerId: string, sessionId: string, memberId: string, params?: { cancelledBy?: string; penaltyExempt?: string }) => {
    const res = await apiClient.delete(`v1/centers/${centerId}/group-sessions/${sessionId}/reserve/${memberId}`, { searchParams: params });
    return { status: res.status, data: await safeJson(res) as CancelResponse | null };
};

export const getReservations = async (centerId: string, sessionId: string) => {
    const res = await apiClient.get(`v1/centers/${centerId}/group-sessions/${sessionId}/reservations`);
    return { status: res.status, data: await safeJson(res) as ReservationsResponse | null };
};

export const updateBookingStatus = async (centerId: string, bookingId: string, body: { status: string }) => {
    const res = await apiClient.patch(`v1/centers/${centerId}/bookings/${bookingId}/status`, { json: body });
    return { status: res.status, data: await safeJson(res) };
};

export const getMemberBookings = async (memberId: string, params?: Record<string, string>) => {
    const res = await apiClient.get(`v1/members/${memberId}/bookings`, { searchParams: params });
    return { status: res.status, data: await safeJson(res) as MemberBookingsResponse | null };
};

export const forcePromoteWaitlist = async (centerId: string, sessionId: string, memberId: string) => {
    const res = await apiClient.post(`v1/centers/${centerId}/group-sessions/${sessionId}/waitlist/${memberId}/promote`);
    return { status: res.status, data: await safeJson(res) };
};
